import { CoreIcon } from '../core-icon';
import chevronDownSVG from '../../../src/images/icons/chevron-down.svg';

export const ChevronDownIcon = props => {
  return <CoreIcon src={chevronDownSVG} {...props} />;
};
